import React, { Component } from "react";
import { DKLabel, DKButton } from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import DataGridHolder from "../common/DataGridHolder";
import FormManager from "./FormManager";
import AppManager from "../../managers/AppManager";
import TemplateManager from "./templates/TemplateManager";
import Table from "../../services/table";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPipelinefetched: false
    };
    this.pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    this.pipeLineData = [];
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    FormManager.setFormData(null);
    this.getPipeline();
  }

  render() {
    return (
      <div className="column parent-width flex-1">
        {/* <DKLabel text="Forms" className="fw-m fs-l" /> */}
        <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width banner-holder">
          <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about creating & managing Job Forms.' />

          <div className="row mt-r ml-l">
            <DKButton
              className="border-m bg-white"
              title="Read"
              onClick={AppManager.showComingSoonWarning}
            />
            <DKButton
              className="border-m ml-r bg-white"
              title="Watch"
              onClick={AppManager.showComingSoonWarning}
            />
          </div>
        </div>
        {this.state.isPipelinefetched && (
          <div className="column parent-width mb-s position-relative flex-1 ">
            <DataGridHolder
              tableName={TABLES.JOB_FORMS}
              module={MODULE.JOB_FORM}
              displayTableName={TABLE_DISPLAY_NAME[TABLES.JOB_FORMS]}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.JOB_FORM, [ACTION.EDIT])}
              allowSearch={true}
              allowFilter={true}
              allowColumnAdd={true}
              allowColumnEdit={PermissionUtils.hasAccess(MODULE.JOB_FORM, [ACTION.EDIT])}
              contextMenu={true}
              onRowEdit={(data) => {
                let data_formatted = {};
                data_formatted.data = {
                  _id: data.rowData.id,
                  cells: data.rowData,
                };
                data_formatted.id = data.rowData.id;

                FormManager.setFormData(data_formatted);
                RouteManager.navigateToPage(
                  PAGE_ROUTES.FORM_BUILDER + "/" + data.rowData.id
                );
              }}
              allowRowAdd={true}
              addButtonConfig={{
                title: "+ New Form",
                className: "bg-app text-white ml-s",
                onClick: () => {
                  FormManager.setFormData(null);
                  TemplateManager.setSelectedTemplateId(null);
                  RouteManager.navigateToPage(PAGE_ROUTES.SELECT_FORM_TEMPLATE);
                },
              }}
            />
          </div>
        )}
      </div>
    );
  }
  getPipeline = () => {
    Table.getRecords(this.pipelineTableId)
      .then((res) => {
        this.pipeLineData = JobPipelineService.getPipelineData(res);
        JobPipelineService.pipelineData = res;
        // this.getStages();
        this.setState({
          isPipelinefetched: true
        })
      })
      .catch((err) => {
        this.setState({
          isPipelinefetched: true
        })
      });
  };
}
